export const savedCreatorsListQueryKeys = {
  all: (workspaceId: string) => [workspaceId, 'saved-creators-list'] as const,
  lists: (workspaceId: string) => [workspaceId, 'saved-creators-list', 'lists'] as const,
  list: (workspaceId: string, listId: string) =>
    [workspaceId, 'saved-creators-list', 'list', listId] as const,
  creators: (workspaceId: string, listId: string) =>
    [workspaceId, 'saved-creators-list', 'detail', listId] as const,
  handles: (workspaceId: string, listId: string) =>
    [workspaceId, 'saved-creators-list', 'handles', listId] as const,
};
